(function ($) {
    "use strict";
    $(function () {


        if ($('.template--marina-city').length) {

            const preloaderAnimatinSettings = {
                container: document.getElementById("preloader"),
                path: `${localize.lottieurl}/preloader.json`,
                renderer: "canvas",
                loop: false,
                autoplay: true,
                name: 'preloader',
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMin slice',
                    viewBoxOnly: true,
                    progressiveLoad: false
                }
            };

            function createPreloader(settings) {
                const preloader = bodymovin.loadAnimation(settings);
                preloader.addEventListener('complete', removePreloader);
                preloader.addEventListener('DOMLoaded', function () {
                    $('.js-template-marina-city').removeClass('loading');
                })
                return preloader;
            }

            function removePreloader() {
                bodymovin.destroy(preloader.name);
                preloaderAnimatinSettings.container.remove();
                $('.js-template-marina-city').removeClass('preloading');
                initAfterPreload();
            }

            function initAfterPreload() {
                initVideoAutoplay();
                initCounters();
            }

            function initVideoAutoplay() {
                $("video").each(function () {
                    $(this).prop({
                        controls: true,
                        controlslist: "nodownload"
                    });
                    const videoObserver = new window.IntersectionObserver(
                        ([entry]) => {
                            if (entry.isIntersecting) {
                                if (this.paused) {
                                    $(this).prop("muted", true);
                                    this.play();
                                }
                            } else {
                                this.pause();
                            }
                        }, {
                        threshold: 0.5,
                    }
                    );
                    videoObserver.observe(this);
                });
            }

            function initCounters() {
                const counters = document.querySelectorAll(".js-counters");
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.intersectionRatio > 0) {
                            entry.target.querySelectorAll(".js-counter").forEach((counter) => {
                                const targetValue = parseFloat(counter.querySelector(".js-counter__number").textContent.replace(/\s/g, '').replace(',', '.'));
                                $.animateCounter(counter.querySelector(".js-counter__number"), targetValue, 5000);
                            });

                            observer.unobserve(entry.target);
                        }
                    });
                });

                counters.forEach((counter) => {
                    observer.observe(counter);
                });
            }

            const isPreloaderHidden = $('.js-template-marina-city').length && !preloaderAnimatinSettings.container;
            const preloader = isPreloaderHidden ? null : createPreloader(preloaderAnimatinSettings);

            if (isPreloaderHidden) {
                initAfterPreload();
            }



            const lottieElements = document.querySelectorAll(".lottie");

            if (lottieElements.length) {
                const configList = Array.from(lottieElements).map(element => ({
                    container: element,
                    path: `${localize.lottieurl}/${element.getAttribute('data-type')}.json`,
                    name: element.getAttribute('data-type')
                }));


                const animations = configList.map(loadLottieAnimation);

                function loadLottieAnimation(item) {


                    let rendererSettings;

                    if (item.name === 'map') {
                        // Specific settings for 'map'
                        rendererSettings = {
                            preserveAspectRatio: 'xMaxYMid meet',
                            viewBoxOnly: true
                        };
                    } else {
                        // Default settings
                        rendererSettings = {
                            preserveAspectRatio: 'xMaxYMin meet',
                            viewBoxOnly: true
                        };
                    }


                    return bodymovin.loadAnimation({
                        ...item,
                        renderer: "svg",
                        loop: true,
                        autoplay: false,
                        rendererSettings: rendererSettings
                    });
                }


                function findAnimationByWrapper(target) {
                    return animations.find(anim => anim.wrapper == target);
                }

                function handleAnimationState(animation, isIntersecting) {
                    const logMessage = `${animation.name || animation.animationID} ${isIntersecting ? 'playing' : 'paused'}`;


                    if (isIntersecting) {
                        animation.play();
                    } else {
                        animation.pause();
                    }
                }

                function lottieCallback(entries) {
                    entries.forEach(({ target, isIntersecting }) => {
                        const animation = findAnimationByWrapper(target);
                        if (animation) {
                            handleAnimationState(animation, isIntersecting);
                        }
                    });
                }

                const lottieObserver = new IntersectionObserver(lottieCallback, {});
                configList.forEach(({ container }) => lottieObserver.observe(container));
            }



        }



    });
})(jQuery);
